<div>
    <his-search-form configFile="{{SEARCH_CONFIG_PROJECT}}">
    </his-search-form>
</div>